import React, { useEffect } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import "./css/SuccessScreen.css";


function SuccessScreen() {

  const navigate = useNavigate();
  const location = useLocation();

  const {
    restaurantId,
    tableId,
  } = useParams();


  const {
    orderId,
    paymentMethod,
    total = 0,
  } = location.state || {};


  const homePath =
    `/${restaurantId}/table/${tableId}`;


  useEffect(() => {

    const timer = setTimeout(() => {

      navigate(homePath);

    }, 10000);


    return () => {
      clearTimeout(timer);
    };

  }, [navigate, homePath]);


  const handleBackToMenu = () => {

    navigate(homePath);

  };


  return (

    <div className="t6-success-page">


      {/* =====================================
          TOP BRAND
      ===================================== */}

      <header className="t6-success-header">

        <div className="t6-success-brand">

          <span className="t6-success-brand-main">
            KAVOS
          </span>

          <span className="t6-success-brand-sub">
            TAVERNA
          </span>

        </div>


        <div className="t6-success-table">

          <span>
            TABLE
          </span>

          <strong>
            {tableId}
          </strong>

        </div>

      </header>



      {/* =====================================
          SUCCESS CONTENT
      ===================================== */}

      <main className="t6-success-main">


        <div className="t6-success-card">


          {/* SUCCESS ICON */}

          <div className="t6-success-icon">

            <div className="t6-success-check">
              ✓
            </div>

          </div>


          {/* EYEBROW */}

          <span className="t6-success-eyebrow">
            ORDER CONFIRMED
          </span>


          {/* TITLE */}

          <h1>
            Efcharistó!
          </h1>


          <p className="t6-success-message">

            Thank you for ordering with
            <strong> Kavos Taverna</strong>.

            <br />

            Your order has been received
            and is being prepared.

          </p>



          {/* =====================================
              ORDER DETAILS
          ===================================== */}

          <div className="t6-success-details">


            <div className="t6-success-detail">

              <span>
                ORDER
              </span>

              <strong>
                #{orderId}
              </strong>

            </div>


            <div className="t6-success-detail">

              <span>
                TABLE
              </span>

              <strong>
                {tableId}
              </strong>

            </div>


            <div className="t6-success-detail">

              <span>
                PAYMENT
              </span>

              <strong>
                {paymentMethod || "ONLINE"}
              </strong>

            </div>


            <div className="t6-success-detail">

              <span>
                TOTAL
              </span>

              <strong>
                ₹{Number(total).toFixed(2)}
              </strong>

            </div>

          </div>



          {/* =====================================
              PREPARING MESSAGE
          ===================================== */}

          <div className="t6-success-preparing">

            <div className="t6-success-preparing-icon">
              ◌
            </div>

            <div>

              <strong>
                Your order is being prepared
              </strong>

              <span>
                Our kitchen has received your order.
              </span>

            </div>

          </div>



          {/* =====================================
              BACK TO MENU
          ===================================== */}

          <button
            type="button"
            className="t6-success-button"
            onClick={handleBackToMenu}
          >

            Back to Menu

            <span>
              →
            </span>

          </button>



          {/* =====================================
              AUTO REDIRECT
          ===================================== */}

          <p className="t6-success-redirect">

            You will be returned to the menu
            automatically in a few seconds.

          </p>


        </div>



        {/* =====================================
            SIDE DECORATION
        ===================================== */}

        <div className="t6-success-decoration">


          <div className="t6-success-circle circle-one"></div>

          <div className="t6-success-circle circle-two"></div>

          <div className="t6-success-circle circle-three"></div>


          <div className="t6-success-quote">

            <span>
              KAVOS TAVERNA
            </span>

            <h2>
              Taste the
              <br />
              Mediterranean.
            </h2>

            <p>
              Fresh seafood.
              Local ingredients.
              Greek hospitality.
            </p>

          </div>


        </div>


      </main>



      {/* =====================================
          FOOTER
      ===================================== */}

      <footer className="t6-success-footer">

        <span>
          KAVOS TAVERNA
        </span>

        <span>
          FRESH · LOCAL · MEDITERRANEAN
        </span>

      </footer>


    </div>

  );

}


export default SuccessScreen;